/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const MusicLibraryIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M1 14V1h13v2H3v11z" />
    <path
      fillRule="evenodd"
      d="M5 5h13v13H5zm11 1-5 2v3.05a2.5 2.5 0 1 0 2 2.45v-3.3L16 9z"
      clipRule="evenodd"
    />
  </g>,
);
